import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingService } from '../_shared';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: [
    '../../assets/css/core-navbar.css',
    '../navbar/navbar.component.css',
    '../user-management/_css/user-management-list.component.css',
    '../notifications/notifications.component.css',
    './search-result.component.css'
  ]
})
export class SearchResultComponent implements OnInit {
  private param: string;
  private currentTab: string;

  constructor(
    private loadingService: LoadingService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // subscribe to param changes
    this.route.paramMap.subscribe(params => {
      this.param = params.get('searchkey');
      console.log(this.param);
    });

    this.switchSearchTab('tickets');
    this.load(false);
  }

  switchSearchTab(tab: string) {
    this.currentTab = tab;
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/search-result/search-result.component.ts